import React from 'react';

export default function IconLayers({fill = '#546878'}) {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill={fill}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.6635 0.552734C12.6484 0.552734 13.4492 1.35212 13.4492 2.33845V11.267C13.4492 12.252 12.6484 13.0527 11.6635 13.0527H2.73493C1.7486 13.0527 0.949219 12.252 0.949219 11.267V2.33845C0.949219 1.35212 1.7486 0.552734 2.73493 0.552734H11.6635ZM11.6635 2.33845H8.09208V5.90988H11.6635V2.33845ZM11.6635 7.69559H8.09208V11.267H11.6635V7.69559ZM6.30636 5.90988V2.33845H2.73493V5.90988H6.30636ZM2.73493 11.267H6.30636V7.69559H2.73493V11.267Z"
                fill="#546878"
            />
        </svg>
    );
}



// WEBPACK FOOTER //
// ./components/icon_layers/index.js